import { useRef } from "react";
import { useLocation } from "react-router-dom";
import { slackNotificationTypes, useSendSlackNotification } from "src/hooks/useNotifications";
import { getUserId, getUserSpecialisationId } from "src/hooks/useUser";

export const useNoCopy = ({ config: { allowCopy, sendOnCopy } }) => {
	const location = useLocation();
	const { mutateAsync } = useSendSlackNotification();
	const timeoutRef = useRef();

	const onCopy = async (e, details = {}) => {
		if (!allowCopy) {
			e.stopPropagation();
			e.preventDefault();
		}

		if (sendOnCopy) {
			clearTimeout(timeoutRef.searchTimeout);
			timeoutRef.searchTimeout = setTimeout(async () => {
				const copiedText = window.getSelection().toString();
				await mutateAsync({
					type: slackNotificationTypes.COPY_CONTENT,
					data: {
						message: "User skopiował content!",
						console: JSON.stringify(
							{
								copiedText,
								...details,
								userId: getUserId(),
								specId: getUserSpecialisationId(),
								href: location.href,
							},
							null,
							2,
						),
					},
				});
			}, 2000);
		}
	};

	return {
		onCopy,
		noCopyClassName: allowCopy ? "" : "no-copy",
	};
};
